import { computed, onMounted, ref, watch } from 'vue';
import { useConvoStore } from 'src/stores/conversations';
import { useLoggingStore } from 'src/stores/logging';
import { of, zip } from 'rxjs';
import { catchError, filter, map, switchMap, tap } from 'rxjs/operators';
import { rxInitSubjectCallback, useObservable } from 'src/plugins/rxjs/base';
/**
 * Plugin containing methods to check if receiver is online
 * @param receiver user id of receiver
 */
const ReceiverOnlinePlugin = (receiver) => {
    const convoStore = useConvoStore();
    const loggingStore = useLoggingStore();
    const receiverOnline = ref(false);
    const convo = computed(() => convoStore.currentConvo);
    const { subject: checkReceiverOnline$ } = rxInitSubjectCallback();
    useObservable(checkReceiverOnline$.pipe(
    // filter(() => !process.env.SERVER),
    filter(v => v !== null), switchMap(() => {
        return import(
        /* webpackChunkName: "firebaseMethod" */
        'src/_helpers/firebaseMethods');
    }), map(({ default: firebaseMethods }) => firebaseMethods), switchMap(firebaseMethods => {
        if (process.env.SERVER) {
            console.log("hit 6");
        }
        return zip(firebaseMethods(), import(
        /* webpackChunkName: "firebaseMethod" */
        'firebase/database'), import(
        /* webpackChunkName: "firebaseRx" */
        'rxfire/database'));
    }), switchMap(([{ database }, { ref: rtdRef }, { fromRef, ListenEvent }]) => {
        return fromRef(rtdRef(database, `/status/${receiver.value}`), ListenEvent.value).pipe(map(({ snapshot }) => snapshot), map(v => {
            const data = v.val();
            if (!data) {
                return false;
            }
            return data.state === 'online';
        }));
    }), catchError(err => {
        loggingStore.errorHandler(err);
        return of(false);
    }), tap((v) => {
        receiverOnline.value = v;
    })));
    onMounted(() => {
        checkReceiverOnline$.next(true);
    });
    watch(convo, (newValue) => {
        if (newValue && newValue.id) {
            checkReceiverOnline$.next(true);
        }
    });
    return {
        receiverOnline
    };
};
export { ReceiverOnlinePlugin };
